module.exports = __webpack_public_path__ + "img/zydj_icon.1426250c.png";